import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/benefits/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/benefits/useGetBenefit";
import validator from "@validators/Clients/WhaleShark/benefits/Benefits.validate";
import formMapper from "@mappers/Clients/WhaleShark/benefits/benefits.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
